import { useEffect } from 'react'

import { useNavigate, Outlet } from 'react-router-dom'
import { VStack, Heading, Center, Button } from '@chakra-ui/react'
import { toast } from 'react-toastify'

const AccessDeniedPage = () => {
  const navigate = useNavigate()
  return (
    <Center h="80%">
      <VStack>
        <Heading>Access Denied </Heading>
        <Button onClick={() => navigate(-2)}>Back </Button>
      </VStack>
    </Center>
  )
}

export default AccessDeniedPage
